import ProgressView from "./ProgressView";
import React from "react";

export const PageLoader = ()=>  <div className="page-content text-center">
                    <ProgressView/>
                </div>
